import { render, staticRenderFns } from "./SingProduct.vue?vue&type=template&id=cef76590&scoped=true"
import script from "./SingProduct.vue?vue&type=script&lang=js"
export * from "./SingProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef76590",
  null
  
)

export default component.exports